<template>
  <ul class="even-columns-grid" ref="anchorTop" v-if="hasArticlesList">
      <li v-for="article in relatedArticleList"
          :key="article.id">
        <article-card :article="article" />
      </li>
  </ul>
  <div class="my-6 lg:h-9 flex justify-center">
    <pagination
      :current-page="currentPage"
      :total-pages="totalPages"
      @update:current-page="updateCurrentPage"/>
  </div>
</template>

<script>
import fetchClient from "../../../../plugins/fetchClient";
import Pagination from "../../ui/Pagination.vue";
import ArticleCard from "../ArticleCard.vue";

export default {
  components: {
    Pagination,
    ArticleCard
  },
  props: {
    articleId: {
      type: [Number, String],
      default: ''
    }
  },
  data() {
    return {
      totalPages: 1,
      currentPage: 1,
      perPage: 4,
      relatedArticleList: []
    }
  },
  watch: {
    currentPage() {
      this.getArticles()
    }
  },
  methods: {
    async getArticles() {
      try {
        const data = await fetchClient(`/articles/${this.articleId}/related_articles`, { queryParams: { page: this.currentPage, per_page: this.perPage } })
        this.relatedArticleList = data["articles"]
        this.totalPages = data["total_pages"]
      } catch(error) {
        console.error(error)
      }
    },
    updateCurrentPage(page) {
      this.currentPage = page
      this.scrollToTop()
    },
    scrollToTop() {
      const element = this.$refs.anchorTop
      const headerHeight = document.getElementsByTagName('header')[0].offsetHeight
      const offsetTop = element.offsetTop - headerHeight
      const currentPosition = document.documentElement.scrollTop || document.body.scrollTop
      if (currentPosition > offsetTop) {
        window.scrollTo({
          top: offsetTop,
          behavior: 'smooth'
        });
      }
    }
  },
  computed: {
    hasArticlesList() {
      return this.relatedArticleList && this.relatedArticleList.length > 0
    },
  },
  mounted() {
    this.getArticles()
  }
}
</script>
